module.exports = __webpack_public_path__ + "img/campaign_01.12e50a15.png";